/*
 * @Author: 黄贺林
 * @Date: 2024-08-29 09:08:43
 * @LastEditTime: 2025-02-24 14:26:26
 * @Description: 在此处清晰,简洁的说明本文件的作用
 */
import global from "@/utils/global.js";
import { lanReceiveTopic } from "@/utils/lanTopic.js";
import { getQueryParam } from "@/utils/common";
import store from "@/store";
import Vue from "vue";
import materialsAll from "@/api/materialsAll";

import { CreateMachClient } from "@/utils/mach_mqtt";

// 设备发现
import { device_notify, search_device } from "@/api/slicer/printer.js";


const vm = Vue.prototype;
const machMqttClients = new Map();

function setObject(uuid, obj) {
  machMqttClients.set(uuid, obj);
}
function getObject(uuid) {
  return machMqttClients.get(uuid);
}


// 创建
export let createMqttLan = async (uuid) => {
  let mqtt = await CreateMachClient(uuid, uuid);
  if (mqtt === undefined) {
    return 1;
  }
  setObject(uuid, mqtt);
  return 0;
};
// 连接
export let setMqttLanConnct = async (mqtt) => {
  const { broker, username, password, devicecrt, devicepk, uuid } = mqtt;
  stateCallback(uuid, (a, c, msg) => {
    lanConnectStatus(mqtt, a, c, msg);
  });
  // if (!store.getters.GET_LAN_MQTT) {
  //   return;
  // }
  const res = await connect(uuid, {
    broker,
    device_type: "fdm",
    username,
    password,
    clientId: vm.$uuid.v1(),
    Certificate: devicecrt,
    PrivateKey: devicepk
  })
  if(res === -1){
    //  销毁重建
    await  disconnect(uuid,true)
    await  createMqttLan(uuid)
    await  setMqttLanConnct(mqtt)
  }
  set_recv(uuid, lanReceiveTopic);
};
// 销毁
export let LanDestoryMqtt = (uuid) => {
  return getObject(uuid)?.destory();
};
// 订阅打印机
export let lanSubscribe = (uuid, topic) => {
  return getObject(uuid)?.subscribe(topic);
};

/**  action 1-7
 enum Action {
  CONNECTED= 0x01， ///<连接已建立。
  DISCONNECTED      ///<与客户端断开连接。
  RECONNECTED，     ///<重新连接到客户端。
  CONNECTION_LOST， ///<连接丢失。
  Subscribe，       ///<订阅一个主题。
  Unsubscribe，     ///<取消订阅某个主题。
  PUBLISH，         ///<将消息发布到主题。
  }
**/
// 打印机连接状态
let lanConnectStatus = async (mqtt, action, code, msg) => {
  const { uuid, modeId, deviceId } = mqtt;

  console.log(`lan_callback====>${uuid}`, action, code);
  if (action === 1 && code === 0) {
    // 连接成功
    updataLanList({
      ...mqtt,
      isConnect: false,
      haveTip: 0,
      retryCount: global.lanCount
    });
    lanSubscribe(
      uuid,
      `anycubic/anycubicCloud/v1/printer/+/${modeId}/${deviceId}/#`
    );
    // 机器
    publish(
      uuid,
      `anycubic/anycubicCloud/v1/web/printer/${modeId}/${deviceId}/info`,
      {
        type: "info",
        action: "query",
        timestamp: new Date().getTime(),
        msgid: `${vm.$uuid.v1()}`,
        data: null
      }
    );

    // 灯光查询
    publish(
      uuid,
      `anycubic/anycubicCloud/v1/web/printer/${modeId}/${deviceId}/light`,
      {
        type: "light",
        action: "query",
        timestamp: new Date().getTime(),
        msgid: `${vm.$uuid.v1()}`,
        data: null
      }
    );
    // materialsAll('getInfoMultiColorBox')
    materialsAll('peripherie')
  } else if ((action === 1 && code != 0) || action == 2) {
    // web主动重连
    if (mqtt?.retryCount > 0) {
      let updateMqtt = {
        ...mqtt,
        isConnect: false,
        haveTip: 1,
        retryCount: mqtt.retryCount - 1
      };
      updataLanList(updateMqtt);
      // 连接mqtt
      setMqttLanConnct(updateMqtt);
    } else {
      updataLanList({ ...mqtt, haveTip: 2, retryCount: global.lanCount });
      // 走设备发现30s
      await device_notify(function () {
        let args = arguments;
        setLanPrinter(mqtt, ...args);
      });
      search_device("fdm", 1, 5000);
    }
  } else if (action == 4) {
    // mqtt主动重连
    updataLanList({ ...mqtt, isConnect: false });
  }

  if ([2, 4].includes(action) || (action === 1 && code != 0)) {
    // 设备离线态
    store.commit("SET_LAN_STATUS_EMPTY", { deviceId: deviceId });
  }
};
// 更新lan打应机列表
let updataLanList = (mqtt) => {
  let LanList = JSON.parse(JSON.stringify(store.getters.GET_LAN_PRINTER_LIST));
  let idx = LanList.findIndex((item) => mqtt.uuid == item.uuid);
  if (idx != -1) {
    LanList[idx] = { ...mqtt };
    store.commit("SET_LAN_PRINTER_LIST", LanList);
  }
};

let findPrinterList = [];
function setLanPrinter(mqtt, p1, p2, p3, p4) {
  // const { uuid } = mqtt;
  console.log("重连====>局域网发现", "p1", p1, "p2", p2, "p3", p3, "p4", p4);
  if (p4 == 1) {
    let needFindArr = store.getters.GET_LAN_PRINTER_LIST.filter((item) => {
      return item.haveTip == "2";
    });
    if (findPrinterList && findPrinterList.length > 0) {
      needFindArr.forEach((findItem) => {
        let isEx = false;
        findPrinterList.forEach((item) => {
          if (item.uuid == findItem.uuid) {
            isEx = true;
            // 用新IP替换旧IP，不使用新账号连接
            let mqtt = { ...findItem };
            let ip = item.ip;
            let oldIp = mqtt.ip;
            mqtt.accountConfirmUrl = mqtt.accountConfirmUrl?.replace(oldIp, ip);
            mqtt.broker = mqtt.broker?.replace(oldIp, ip);
            mqtt.ip = mqtt.ip?.replace(oldIp, ip);
            mqtt.viewUrl = mqtt.viewUrl?.replace(oldIp, ip);
            mqtt.accountDeleteUrl = mqtt.accountDeleteUrl?.replace(oldIp, ip);
            mqtt.timestamp = new Date().valueOf();
            setMqttLanConnct(mqtt);
            store.dispatch("SET_LAN_MQTT", mqtt);
            store.commit("SET_PRINTER_TYPE", "lan");
            // 处理列表
            let LanList = JSON.parse(
              JSON.stringify(store.getters.GET_LAN_PRINTER_LIST)
            );
            let idx = LanList.findIndex((item) => findItem.uuid == item.uuid);
            if (idx != -1) {
              LanList[idx] = { ...mqtt };
              store.commit("SET_LAN_PRINTER_LIST", LanList);
            }
          }
        });
        if (!isEx) {
          updataLanList({ ...findItem, haveTip: 3 });
        }
      });
    } else {
      needFindArr.forEach((findItem) => {
        // 设备发现未找到设备
        updataLanList({ ...findItem, haveTip: 3 });
      })
    }
  }
  const urlParams = new URLSearchParams(p3);
  let obj = {
    name: getQueryParam(p3, "deviceName"),
    model: urlParams.get("modelName"),
    cn: getQueryParam(p3, "cn"),
    img: "",
    url: p3
  };
  const ctrlType = getQueryParam(p3, "ctrlType");
  if (ctrlType == "lan") {
    obj.uuid = p1; //唯一值局域网
    obj.ip = getQueryParam(p3, "ip");
    if (p4 == 0) {
      // 去重
      let res1 = findPrinterList.find((i) => i.uuid == p1);
      if (res1) return false;
      findPrinterList.push(obj);
    }
  }
}

/**
 * @describe 连接mqtt服务器
 *
 * @param url 服务器地址，格式`mqtt[s]://host[:port]`，eg: mqtt://192.168.1.100:1883
 * @param device_type 设备类型:lcd;fdm
 * @param username 用户名
 * @param password 密码
 * @param Certificate 根证书
 * @param PrivateKey 客户端证收私钥
 * @param KeyStore 客户端证书
 * @note  当首次连接时，使用相关参数进行连接，已有连接仅取出连接使用，相关参数忽略
 *
 * @returns 成功返回0,失败返回错误代码
 */
export function connect(
  uuid,
  {
    broker,
    device_type,
    username,
    password,
    Certificate,
    PrivateKey,
    KeyStore,
    clientId
  }
) {
  console.log(getObject(uuid), 'getObject(uuid)')
  return getObject(uuid)?.connect(
    broker,
    device_type,
    username,
    password,
    clientId,
    Certificate,
    PrivateKey,
    KeyStore ? KeyStore : ""
  );
}

// 订阅打印机所有
export function subscribe_printer(uuid, model_id, devicer_id) {
  return getObject(uuid)?.subscribe_printer(model_id, devicer_id);
}

/**
 * @describe 取消订阅主题
 *
 * @param topic 主题名称
 * @returns 成功返回0,失败返回错误代码
 */
export function unsubscribe(uuid, topic) {
  return getObject(uuid)?.unsubscribe(topic);
}

/**
 * @describe 发布消息
 *
 * @param topic 主题名称
 * @param payload 载荷
 * @returns 成功返回0,失败返回错误代码
 */
export function publish(uuid, topic, payload) {
  return getObject(uuid)?.publish(topic, payload);
}

/**
 * @describe 断开连接
 *
 * @returns 成功返回0,失败返回错误代码
 */
export function disconnect(uuid,faild=false) {
  return getObject(uuid)?.disconnect(faild);
}

/**
 * @describe 注册消息接收回调
 *
 * @param callback 回调函数
 * @returns 成功返回0,失败返回错误代码
 */
export function set_recv(uuid, callback) {
  return getObject(uuid)?.set_message_callback(callback);
}

// // 是否连接成功
// export async function isConnect(uuid){
//   return await hostObjects[uuid].connected;
// }

// 连接状态回调
export function stateCallback(uuid, callback) {
  return getObject(uuid)?.set_event_callback(callback);
}
